import { useCallback, useEffect, useState } from 'react';

export const useSplashStartup = (
  authenticated: boolean,
  accountId: string | undefined,
  appearancePending: boolean,
  source: string,
) => {
  const [initializedAccountId, setInitializedAccountId] = useState<string>();
  const [readyMedia, setReadyMedia] = useState<string>();
  const [expiredMedia, setExpiredMedia] = useState<string>();
  const visible = authenticated && (!accountId || initializedAccountId !== accountId);
  const mediaReady = readyMedia === source || expiredMedia === source;
  const applicationReady = Boolean(accountId) && !appearancePending && mediaReady;

  const onMediaReady = useCallback(() => setReadyMedia(source), [source]);

  useEffect(() => {
    if (authenticated) return;
    setInitializedAccountId(undefined);
    setReadyMedia(undefined);
    setExpiredMedia(undefined);
  }, [authenticated]);

  useEffect(() => {
    if (!visible || appearancePending) return;
    // Falha de rede da mídia não pode prender a pessoa na tela de abertura.
    const timer = setTimeout(() => setExpiredMedia(source), 4000);
    return () => clearTimeout(timer);
  }, [visible, appearancePending, source]);

  useEffect(() => {
    if (visible && applicationReady) setInitializedAccountId(accountId);
  }, [visible, applicationReady, accountId]);

  return { visible, onMediaReady };
};
